import React from "react";
import styled from "styled-components";

const IosCheckBox = ({
  children,
  checked = false,
  text = "",
  id = "ios-checkbox",
  onChange = () => { },
  ...rest
}) => {
  return (
    <Label className="container" for={id}>
      <Input id={id} type="checkbox" onChange={onChange} checked={checked} {...rest} />
      <Checkmark className="checkmark"></Checkmark>
      {text ? <TextWrapper>{text}</TextWrapper> : null}
      {children}
    </Label>
  )
};

export default IosCheckBox;

const Label = styled.label`
  display: flex;
  position: relative;
  padding-left: 0px;
  padding-bottom: 0px;
  line-height: 20px;
  margin-right: 0px;
  font-size: inherit;
  user-select: none;
  color: ${({ theme }) => theme.textPrimary};
  font-weight: normal;
  cursor: pointer;

  .regsitration-terms {
    margin-left: 1rem;
    font-size: 1rem;
    color: ${({ theme }) => theme.textPrimary};
  }

  input:checked ~ .checkmark {
    background-color: #17bed0;
    border: none;

    &:after {
      display: block;
    }
  }
`;

const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

const TextWrapper = styled.div`
  margin-left: 0.625rem;
  font-size: 1.063rem;
`;

const Checkmark = styled.span`
  position: relative;
  top: 0px;
  left: 0px;
  flex-shrink: 0;
  height: 20px;
  width: 20px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.inputBackground};
  border: solid 1px #a1a1a1;

  &:after {
    content: "";
    position: absolute;
    display: none;
    left: 7px;
    top: 3px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;
